import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoginService} from '../../services/login.service';
import {BaseComponent} from '../BaseComponent';
import {UserService} from '../../services/api/UserService';
import * as toastr from 'toastr';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {User} from '../../models/User';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  username: string;
  loginForm: FormGroup;
  submitted = false;

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute,
              private loginService: LoginService, private userService: UserService,
              private loaderService: LoaderService, private formBuilder: FormBuilder) {
    super(route, router);
  }

  async ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.maxLength(20)]],
      password: ['', [Validators.required, Validators.maxLength(20)]]
    });
  }

  ngOnDestroy() {
  }

  get f() { return this.loginForm.controls; }

  async onSignin() {
    this.submitted = true;
    if (this.loginForm.valid) {
      const user = new User();
      event.preventDefault();
      sessionStorage.clear();
      this.loaderService.display(true);
      user.username = this.loginForm.value.username;
      user.password = this.loginForm.value.password;
      this.loginService.getAccessToken(user.username, user.password).subscribe(
        (res: any) => {
          this.loginService.getUserByUsername(null, user).subscribe(
            (result: any) => {
              if (result) {
                toastr.success('User logged in with success', 'Success');
                this.loaderService.display(false);
                sessionStorage.setItem('user', JSON.stringify(result));
                this.router.navigate([this.LINKS.HOMEPAGE]);
              } else {
                toastr.error('Username not valid', 'Alert');
                this.username = '';
                this.loaderService.display(false);
              }

            },
            error => {
              this.loaderService.display(false);
              toastr.error('Username does not exist', 'Error');
            });
        },
        error => {
          this.loaderService.display(false);
          toastr.error('Unauthorized', 'Error');
        });
    }
  }

  async getCurrentUser() {
    return this.userService.currentUser().then(response => {
      sessionStorage.setItem(this.USER_ID, response.id.toString());
    });
  }

}
